import styled, { css } from 'styled-components'

type IsMobile = {
  isMobile: boolean
}

export const Container = styled.div<IsMobile>`
  .thanks-text {
    color: #898989;
    margin-bottom: 8px;
  }

  > h2, h4 {
    max-width: 346px;
  }

  ${({ isMobile }) => isMobile && css`
    > h4 {
      max-width: 300px;
    }
  `}
`

export const ProfessionalInfoWrapper = styled.div<IsMobile>`
  margin-top: 20px;
  display: flex;
  align-items: center;
  gap: 10px;

  ${({ isMobile }) => isMobile && css`
    justify-content: center;
  `}
`